import { Autocomplete, TextField } from "@mui/material";
import { GridRenderEditCellParams, useGridApiContext } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import JustificativaDomain from "../classes/JustificativaDomain";
import JustificativaDataset from "../data/JustificativaDataSet";

export default function AutocompleteJustificativaCommon(
  props: AutocompleteJustificativaCommonPropsTypes
) {
  const carregando: string = "Carregando...";
  const apiRef = useGridApiContext();
  const [justificativas, setJustificativas] = useState<string[]>([carregando]);

  const justificativaDataset: JustificativaDataset = new JustificativaDataset();

  useEffect(() => {
    justificativaDataset.ListarAtivos().then((result) => {
      setJustificativas(
        result
          .filter((justificativa) => justificativa.categoria == props.tipo)
          .map((item) => item.descricao)
      );
    });
  }, []);

  return (
    <>
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        options={justificativas}
        sx={{ width: 300 }}
        value={props.gridItem.value}
        onChange={(event: any, newValue: string | null) => {
          apiRef.current.setEditCellValue({
            id: props.gridItem.id,
            field: props.gridItem.field,
            value: newValue == null || newValue == carregando ? "" : newValue,
          });
        }}
        renderInput={(params) => <TextField {...params} />}
      />
    </>
  );
}

interface AutocompleteJustificativaCommonPropsTypes {
  gridItem: GridRenderEditCellParams;
  tipo: string;
}
